import React from "react"

const Ourmission = () => {
	return (
		<div className='container-lg'>
			<div className='our-mission row justify-content-center align-items-center py-2'>
				<div className='our-mission-inner text-center col-12 col-sm-10 col-xl-10'>
					<p className='heading h1 text-lowercase font-weight-600 mb-3'>OUR MISSION</p>
					<div className='inner-content text-dark h5 font-weight-light '>
						<p className='mb-0'>
							We aim to connect students through entrepreneurial
							based projects that empower people to transform
							opportunities into real, sustainable progress for
							themselves and their communities.
						</p>
						<p>
							We are shaping the succeeding generation of socially
							responsible leaders.
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Ourmission
